import { defineComponent as e } from "vue";
const n = e({
  name: "TuiPlaceholder"
});
export {
  n as default
};
//# sourceMappingURL=Placeholder.vue2.mjs.map
